<template lang="pug">
<router-view />
</template>

<script>
import './init'
export default {
  name: 'App',
  created () {
    this.$store.dispatch('socketInit')
    this.$q.iconMapFn = (iconName) => {
      if (iconName.startsWith('d-') === true) {
        return {
          cls: 'dayicon ' + iconName
        }
      }
    }
  },
  computed: {
    authenticated: {
      get () {
        return this.$store.state.User.authenticated
      }
    }
  },
  methods: {
  },
  watch: {
    authenticated (val) {
      const context = this.$store
      if (val) {
        setTimeout(() => {
          context.dispatch('socketEnroll')
        }, 1000)
      } else {
        context.dispatch('socketUnenroll')
      }
    }
  }
}
</script>

<style>
</style>
